import styled from '@emotion/styled';

export const SidebarContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 260px;
  padding: 15px 10px;
  border-left: 1px solid #c1c1c1;
  box-shadow: 0 0 5px #00000075;
  background: #fff;
  &:after {
    content: '';
    display: block;
    width: 260px;
  }
`;
